import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { Content } from "core/layouts";
import { BaasicModal, BaasicFieldDropdown, BaasicDropdown, BasicInput, BaasicButton, BasicFieldCheckbox, BaasicFormControls } from "core/components";
import { observer } from "mobx-react";
import { uuid, toDate } from "core/utils";
import { DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import { FacilityOrderTemplateAddNoteModal, FacilityOrderTemplateValidationModal, FacilityOrderTemplateMissingDocumentNoteModal, FacilityOrderTemplatePNMissingInformationModal } from "application/facility-order/components";

const FacilityOrderTemplateItemEditTemplate = function ({ facilityOrderTemplateItemEditViewStore, brightreeBaseUrl, deleteNewTemplate, t }) {
	const {
		item,
		facilityOrderTemplateItems,
		facilityOrderTemplateValidations,
		facilityOrderTemplateNotes,
		renderValidationsTitle,
		addItem,
		facilityOrderTemplateAddNoteModal,
		openFacilityOrderTemplateAddNoteModal,
		importFacilityOrderTemplate,
		generateMedicalNecessityForm,
		isMedicalNecessityFormCategory,
		saveItemOnProductSelect,
		updateFacilityOrderTemplateNotesActivity,
		deleteAndAddItem,
		setImportActionToDeleteAndAddItem,
		deleteItem,
		setImportActionToDelete,
		editItem,
		calculateQuantity,
		contentLoading,
		form,
		referenceStore,
		productStore,
		updateTemplateItems,
		branchStore,
		inactiveReasonStore,
		createTrackingCase,
		isEnteralTemplate,
		isWoundCareTemplate,
		isImportActionDelete,
		isNewItem,
		isNewTemplate,
		isNotFoundImportReference,
		templateItemsRowRefs,
		setRowImportActionStatusColor,
		isMatchReference,
		isImportDetailStatusImported,
		isImportDetailStatusFaild,
		isReadOnly,
		isQtyReadOnly,
		checkMatchReference,
		saveOnReviewed,
		isDirty,
		missingDocumentStore,
		isMissingDocument,
		validationMessage,
		showProductList,
		goToTrackingCase,
		facilityOrderTemplateValidationModal,
		openFacilityOrderTemplateValidationModal,
		isStandardWrittenOrderCategory,
		generateStandardWrittenOrder,
		isReloadTemplateEnabled,
		reloadFacilityOrderTemplate,
		isNoneInactiveReason,
		editMissingDocumentNote,
		facilityOrderTemplateMissingDocumentNoteModal,
		formSubmit,
		isSecondaryInsuranceVerified,
		dxCode1Store,
		dxCode2Store,
		dxCode3Store,
		dxCode4Store,
		dxCode5Store,
		dxCode6Store,
		dxCode7Store,
		dxCode8Store,
		isExistDxCode1,
        isExistDxCode2,
        isExistDxCode3,
        isExistDxCode4,
		isExistDxCode5,
        isExistDxCode6,
        isExistDxCode7,
        isExistDxCode8,
		facilityOrderTemplatePNMissingInformationModal
	} = facilityOrderTemplateItemEditViewStore;
	const importReferenceDropdownItemRender = (li, itemProps) => {
		const billableToInsuranceIcon = itemProps && itemProps.dataItem.isBillableToMedicare ?
			<i style={{
				display: "inline-block",
				marginRight: "7px"
			}} className="u-icon u-icon--sml u-icon--active"></i> : null;

		const itemChildren = (
			<span style={{
				display: "flex",
				width: "100%",
				padding: "2px 0",
				alignItems: "center"
			}}
			>
				{billableToInsuranceIcon}
				<span style={{ flex: "1" }}>
					{li.props.children}
				</span>
			</span>
		);

		return React.cloneElement(li, li.props, itemChildren);
	}

	const importReferenceDropdownSelectedValueRender = (element, value) => {
		if (!value) {
			return element;
		}
		var insurance = value && value.insurance ? value.insurance.name : '';
		const itemName = value && value.name;
		const billableToInsuranceIcon = value && value.isBillableToMedicare ?
			<i key={uuid()} style={{ marginRight: "7px" }} className="u-icon u-icon--sml u-icon--active"></i> : null;
		checkMatchReference(insurance, value.isBillableToMedicare);
		const children = [
			billableToInsuranceIcon,
			<span
				key={uuid()}
				style={{
					display: "inline-block",
					height: "18px",
					textAlign: "center",
					overflow: "hidden",
				}}
			>
				{itemName}
			</span>
		];
		return React.cloneElement(element, { ...element.props }, children);
	};

	const tagRender = (tagData, li) => React.cloneElement(li, { children: <span key={uuid()} onClick={() => editMissingDocumentNote(tagData.data[0])}>{tagData.data[0].name}</span> });

	const dxCodeDropdownItemRender = (li, itemProps) => {
		const itemName = itemProps && itemProps.dataItem.name;
		const itemChildren = (
			<span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
				<span style={{ flex: "1" }}> {li.props.children} </span>
				<span style={{ fontSize: "12px" }}>{itemName} </span>
			</span>
		);
		return React.cloneElement(li, li.props, itemChildren);
	}

	const handleDropDownItemsOnClick = async (e) => {
		if (e.item.text === "Add Tracking Case") {
			createTrackingCase(item);
		}
		else if (e.item.text === "Add Item") {
			addItem();
		}
		else if (e.item.text === "Delete Template") {
			deleteNewTemplate(item.id, item.linkedTemplateId);
		}
		else if (e.item.text === "Add Note") {
			openFacilityOrderTemplateAddNoteModal(item.id);
		}
		else if (e.item.text === "Import") {
			importFacilityOrderTemplate(item.id);
		}
		else if (e.item.text === "Generate PN") {
			generateMedicalNecessityForm(item.id);
		}
		else if (e.item.text === "Generate SWO") {
			await generateStandardWrittenOrder(item.id);
		}
		else if (e.item.text === "Reload Template") {
			await reloadFacilityOrderTemplate(item.id);
		}
	}

	const facilityOrderTemplateNote = facilityOrderTemplateNotes ? facilityOrderTemplateNotes.map(i => {
		return (
			<div className="row u-padd--top--tny" key={i.id}>
				<i className={`c-pointer u-icon u-icon--sml u-icon--flag--${i.isActive ? "red" : "grey"} w--5 u-padd--x--none--no-inherit`} onClick={() => isReadOnly ? {} : updateFacilityOrderTemplateNotesActivity(i)}></i>
				<i style={{ color: i.isActive ? "red" : "grey" }} onDoubleClick={() => isReadOnly ? {} : openFacilityOrderTemplateAddNoteModal(i.facilityOrderTemplateId, i.id, i.note, i.isActive)}> {i.note && `${toDate(i.dateCreated)} ${i.note}`}</i>
			</div>
		);
	}
	) : [];

	const inactiveReason = item != null && ((item.inactiveReason == "Hospital" || item.inactiveReason == "Expired" || item.inactiveReason == "Discharged") && item.isReviewed);
	const backgroundColor = isImportDetailStatusImported ? "#edf7ed" : isImportDetailStatusFaild ? "#f7e9e6" : item != null && item.templateId != null ? (item.notCurrent === true || inactiveReason === true) ? "#ebebe6" : "white" : "aliceblue";
	return (
		item ?
			<div style={{ backgroundColor: backgroundColor }} className="container u-padd--top--sml">
				<div className="content__main">
					<Content loading={contentLoading}>
						<div className="row">
							<div className="col col-lrg-9">
								<div className="row">
									<div className="col u-mar--right--sml">
										<b>Template: </b>
										{
											isNewTemplate() ?
												<span>NEW</span> :
												<span>
													<a target='_blank' href={`${brightreeBaseUrl}OrderEntry/frmSOOrderRO.aspx?SalesOrderTemplateKey=${item.templateId}&Edit=0`}>{item.templateId}</a>
												</span>
										}
									</div>
									{item.salesOrderId &&
										<div className="col u-mar--right--sml">
											<b>Sales Order: </b>
											{
												<span>
													<a target='_blank' href={`${brightreeBaseUrl}OrderEntry/frmSOOrderRO.aspx?SalesOrderKey=${item.salesOrderId}&ShowAck=-1&Edit=0`}>{item.salesOrderId}</a>
												</span>
											}
										</div>
									}
									<div className="col u-mar--right--sml">
										Sub Category: <b>{item.subCategory && item.subCategory.name}</b>
									</div>
									<div className="col u-mar--right--sml">
										<b>Tracking Case: </b>
										{item.trackingCase ? <a onClick={() => goToTrackingCase(item.trackingCase)}><b>{item.trackingCase.docCode}</b></a> : <b>{"/"}</b>}
									</div>
									<div className="col u-mar--right--sml">
										<div className="u-flex--align-start">
											<div>
												<BasicFieldCheckbox field={form.$('isReviewed')} disabled={isReadOnly} onChange={(e) => {
													saveOnReviewed(e);
												}} />
											</div>
											<label className="u-mar--right--sml">Reviewed</label>
										</div>
									</div>
									<div className="col u-mar--right--sml">
										<div className="u-flex--align-start">
											<div>
												<BasicFieldCheckbox field={form.$('missingProduct')} disabled={isReadOnly} />
											</div>
											<label className="u-mar--right--sml">Missing Product</label>
										</div>
									</div>
									{isNoneInactiveReason && facilityOrderTemplateValidations.length !== 0 &&
										<span>
											<a onClick={() => openFacilityOrderTemplateValidationModal()}>
												<i
													className={`u-icon u-icon--xmed u-icon--add-pump`}
													title={renderValidationsTitle(facilityOrderTemplateValidations)}
												>
												</i>
											</a>
										</span>
									}
									<div style={{ color: "red" }} className="col u-mar--right--sml">
										<b>{isNoneInactiveReason && validationMessage}</b>
									</div>
									{isImportDetailStatusFaild &&
										<div style={{ color: "red" }} className="col u-mar--right--sml">
											<b>{item.errorMessage}</b>
										</div>
									}
								</div>
							</div>
							<div className="col u-mar--left--auto">
								<div className="u-flex--primary">
									<BaasicFormControls form={form} disabled={(isReadOnly && !isImportDetailStatusImported) || (!form.isDirty && !isDirty)} onSubmit={form.onSubmit} />
									<DropDownButton
										buttonClass="btn btn--base btn--ghost"
										className="u-mar--left--tny"
										text="Actions"
										size={"medium"}
										themeColor={"primary"}
										fillMode={"solid"}
										onItemClick={(e) => handleDropDownItemsOnClick(e)}
									>
										<DropDownButtonItem text="Add Tracking Case" disabled={isReadOnly || isImportDetailStatusImported} />
										<DropDownButtonItem text="Add Item" disabled={isReadOnly || isImportDetailStatusImported} />
										{isNewTemplate() && <DropDownButtonItem text="Delete Template" disabled={isReadOnly || isImportDetailStatusImported} />}
										<DropDownButtonItem text="Add Note" disabled={isReadOnly || isImportDetailStatusImported} />
										{isMedicalNecessityFormCategory() && <DropDownButtonItem text="Generate PN" />}
										{isStandardWrittenOrderCategory() && <DropDownButtonItem text="Generate SWO" />}
										<DropDownButtonItem text="Import" disabled={!item.isReviewed || isImportDetailStatusImported} />
										{isReloadTemplateEnabled && <DropDownButtonItem text="Reload Template" disabled={isReadOnly || isImportDetailStatusImported} />}
									</DropDownButton>
								</div>
							</div>
						</div>
						<div className="row row--form">
							<div className={`form__group u-flex--default col ${isWoundCareTemplate() ? "col-med-2 " : "col-med-3"}`} >
								<div className={isNotFoundImportReference ? "w--95" : "w--100"}>
									<div className='form__group__label'>
										<div className="row">
											<div className="col col-sml-10">
												Reference <span style={{ color: "red" }}>*</span>
											</div>
											<div className='col col-sml-2 type--right'>
												{(isNoneInactiveReason && !isMatchReference) &&
													<i title='Insurance does not match primary insurance on the patient' className="u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>
												}
											</div>
										</div>
									</div>
									<BaasicFieldDropdown disabled={isReadOnly} labelDisplayed={false} field={form.$('importReferenceId')} store={referenceStore} itemRender={importReferenceDropdownItemRender} valueRender={importReferenceDropdownSelectedValueRender} />
								</div>
								{isNotFoundImportReference &&
									<i title={`Brightree Reference - ${item.reference}`} className="u-icon u-icon--sml u-icon--flag--red w--5 u-padd--x--none--no-inherit"></i>
								}
							</div>
							<div className="form__group col col-med-2">
								<BaasicFieldDropdown disabled={isReadOnly} field={form.$('inactiveReasonId')} store={inactiveReasonStore} />
							</div>
							<div className={isWoundCareTemplate() ? "form__group col col-med-2" : "form__group col col-med-3"} >
								<BasicInput disabled={isReadOnly} field={form.$('insuranceInfo')} />
							</div>
							<div className="form__group col col-med-2">
								<label className="form__group__label">
									<div className="row">
										<div className="col col-sml-10">
											{t("FACILITY_ORDER_TEMPLATE.EDIT.SECONDARY_INSURANCE_VERIFIED_LABEL")}
										</div>
										<div className='col col-sml-2 type--right'>
											{(isSecondaryInsuranceVerified && form.$('secondaryInsuranceVerified').value === "") &&
												<i title='The Secondary Insurance Verified is required.' className="u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>
											}
										</div>
									</div>
								</label>
								<BasicInput disabled={isReadOnly} field={form.$('secondaryInsuranceVerified')} />
							</div>
							<div className="form__group col col-med-2">
								<BasicInput disabled={isReadOnly} field={form.$('swo')} />
							</div>
							{isWoundCareTemplate() && <div className="form__group col col-med-2">
								<BasicInput disabled={isReadOnly} field={form.$('woundLocation')} />
							</div>}
						</div>
						<div className="row">
							<div className={isWoundCareTemplate() ? "form__group col col-med-4" : "form__group col col-med-5"}>
								<BasicInput disabled={isReadOnly} field={form.$('note')} />
							</div>
							<div className={isWoundCareTemplate() ? "form__group col col-med-2" : "form__group col col-med-3"}>
								<BaasicFieldDropdown disabled={isReadOnly} field={form.$('branchId')} store={branchStore} />
							</div>
							<div className="form__group col col-med-1">
								<div className="form__group__label">
									<div className="row">
										<div className="col col-sml-9"> {t(form.$('dxCode1').label)}</div>
										<div className='col col-sml-2 type--right'>
											{(isNoneInactiveReason && !isExistDxCode1) &&
												<i title='Dx Code is not billable' className="type--right u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>
											}
										</div>
									</div>
								</div>
								<BaasicFieldDropdown field={form.$('dxCode1')} store={dxCode1Store} allowEmpty={true} disabled={isReadOnly} itemRender={dxCodeDropdownItemRender} labelDisplayed={false}/>
							</div>
							<div className="form__group col col-med-1">
								<div className="form__group__label">
									<div className="row">
										<div className="col col-sml-9"> {t(form.$('dxCode2').label)}</div>
										<div className='col col-sml-2 type--right'>
											{(isNoneInactiveReason && !isExistDxCode2) &&
												<i title='Dx Code is not billable' className="type--right u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>
											}
										</div>
									</div>
								</div>
								<BaasicFieldDropdown field={form.$('dxCode2')} store={dxCode2Store} allowEmpty={true} disabled={isReadOnly} itemRender={dxCodeDropdownItemRender} labelDisplayed={false}/>
							</div>
							<div className="form__group col col-med-1">
								<div className="form__group__label">
									<div className="row">
										<div className="col col-sml-9"> {t(form.$('dxCode3').label)}</div>
										<div className='col col-sml-2 type--right'>
											{(isNoneInactiveReason && !isExistDxCode3) &&
												<i title='Dx Code is not billable' className="type--right u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>
											}
										</div>
									</div>
								</div>
								<BaasicFieldDropdown field={form.$('dxCode3')} store={dxCode3Store} allowEmpty={true} disabled={isReadOnly} itemRender={dxCodeDropdownItemRender} labelDisplayed={false}/>
							</div>
							<div className="form__group col col-med-1">
								<div className="form__group__label">
									<div className="row">
										<div className="col col-sml-9"> {t(form.$('dxCode4').label)}</div>
										<div className='col col-sml-2 type--right'>
											{(isNoneInactiveReason && !isExistDxCode4) &&
												<i title='Dx Code is not billable' className="type--right u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>
											}
										</div>
									</div>
								</div>
								<BaasicFieldDropdown field={form.$('dxCode4')} store={dxCode4Store} allowEmpty={true} disabled={isReadOnly} itemRender={dxCodeDropdownItemRender} labelDisplayed={false}/>
							</div>
							<div className="form__group col col-med-1">
								<div className="form__group__label">
									<div className="row">
										<div className="col col-sml-9"> {t(form.$('dxCode5').label)}</div>
										<div className='col col-sml-2 type--right'>
											{(isNoneInactiveReason && !isExistDxCode5) &&
												<i title='Dx Code is not billable' className="type--right u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>
											}
										</div>
									</div>
								</div>
								<BaasicFieldDropdown field={form.$('dxCode5')} store={dxCode5Store} allowEmpty={true} disabled={isReadOnly} itemRender={dxCodeDropdownItemRender} labelDisplayed={false}/>
							</div>
							<div className="form__group col col-med-1">
								<div className="form__group__label">
									<div className="row">
										<div className="col col-sml-9"> {t(form.$('dxCode6').label)}</div>
										<div className='col col-sml-2 type--right'>
											{(isNoneInactiveReason && !isExistDxCode6) &&
												<i title='Dx Code is not billable' className="type--right u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>
											}
										</div>
									</div>
								</div>
								<BaasicFieldDropdown field={form.$('dxCode6')} store={dxCode6Store} allowEmpty={true} disabled={isReadOnly} itemRender={dxCodeDropdownItemRender} labelDisplayed={false}/>
							</div>
							<div className="form__group col col-med-1">
								<div className="form__group__label">
									<div className="row">
										<div className="col col-sml-9"> {t(form.$('dxCode7').label)}</div>
										<div className='col col-sml-2 type--right'>
											{(isNoneInactiveReason && !isExistDxCode7) &&
												<i title='Dx Code is not billable' className="type--right u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>
											}
										</div>
									</div>
								</div>
								<BaasicFieldDropdown field={form.$('dxCode7')} store={dxCode7Store} allowEmpty={true} disabled={isReadOnly} itemRender={dxCodeDropdownItemRender} labelDisplayed={false}/>
							</div>
							<div className="form__group col col-med-1">
								<div className="form__group__label">
									<div className="row">
										<div className="col col-sml-9"> {t(form.$('dxCode8').label)}</div>
										<div className='col col-sml-2 type--right'>
											{(isNoneInactiveReason && !isExistDxCode8) &&
												<i title='Dx Code is not billable' className="type--right u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>
											}
										</div>
									</div>
								</div>
								<BaasicFieldDropdown field={form.$('dxCode8')} store={dxCode8Store} allowEmpty={true} disabled={isReadOnly} itemRender={dxCodeDropdownItemRender} labelDisplayed={false}/>
							</div>
							{isMissingDocument ?
								<div className={"form__group col col-med-4"} >
									<BaasicFieldDropdown disabled={isReadOnly && !isImportDetailStatusImported} field={form.$('facilityOrderTemplateMissingDocuments')} store={missingDocumentStore} multi={true} tagRender={tagRender} />
								</div>
								: ""
							}
						</div>
						<div className="table--preview__wrap">
							<TemplateItemsTable
								templateItems={facilityOrderTemplateItems}
								editItem={editItem}
								calculateQuantity={calculateQuantity}
								saveItemOnProductSelect={saveItemOnProductSelect}
								deleteAndAddItem={deleteAndAddItem}
								setImportActionToDeleteAndAddItem={setImportActionToDeleteAndAddItem}
								deleteItem={deleteItem}
								setImportActionToDelete={setImportActionToDelete}
								productStore={productStore}
								updateTemplateItems={updateTemplateItems}
								isEnteralTemplate={isEnteralTemplate}
								isReadOnly={isReadOnly}
								isQtyReadOnly={isQtyReadOnly}
								isImportActionDelete={isImportActionDelete}
								isNewItem={isNewItem}
								templateItemsRowRefs={templateItemsRowRefs}
								setRowImportActionStatusColor={setRowImportActionStatusColor}
								isNewTemplate={isNewTemplate}
								linkedTemplateId={item.linkedTemplateId}
								subCategory={item.subCategory}
								showProductList={showProductList}
								formSubmit={formSubmit}
							/>
						</div>

						<div className="form__group col col-lrg-12 u-mar--bottom--sml u-mar--top--sml">
							{facilityOrderTemplateNote}
						</div>

						<BaasicModal modalParams={facilityOrderTemplateAddNoteModal}>
							<FacilityOrderTemplateAddNoteModal />
						</BaasicModal>
						<BaasicModal modalParams={facilityOrderTemplateValidationModal}>
							<FacilityOrderTemplateValidationModal />
						</BaasicModal>
						<BaasicModal modalParams={facilityOrderTemplateMissingDocumentNoteModal}>
							<FacilityOrderTemplateMissingDocumentNoteModal />
						</BaasicModal>
						<BaasicModal modalParams={facilityOrderTemplatePNMissingInformationModal} className="modal__content modal--med">
							<FacilityOrderTemplatePNMissingInformationModal />
						</BaasicModal>
					</Content>
				</div>
			</div>
			:
			<div></div>
	);
};

FacilityOrderTemplateItemEditTemplate.propTypes = {
	facilityOrderTemplateItemEditViewStore: PropTypes.object.isRequired,
	t: PropTypes.func,
	brightreeBaseUrl: PropTypes.string,
	deleteNewTemplate: PropTypes.func,
	showProductList: PropTypes.func
};

// Develop wrapped this class with `@observer`; the mobx-undecorate
// codemod stripped the decorator without converting to the new
// `observer(Component)` call form, so the table stopped subscribing
// to the observables it reads. Restore the wrap.
const TemplateItemsTable = observer(class TemplateItemsTable extends React.Component {
	constructor(props) {
		super(props);
	}

	selectValue = (e) => e.target.select();
	productDropdownItemRender = (li, itemProps) => {
		const itemName = itemProps && itemProps.dataItem.description;
		const isPreferredIcon = itemProps && itemProps.dataItem.isPreferred && this.props.subCategory && this.props.subCategory.abrv == "Ostomy-Products" ?
			<i style={{
			}} className="u-icon u-icon--xsml u-icon--star-outlined u-mar--right--tny"></i>
			: null;
		const itemChildren = (
			<span
				style={{
					display: "flex",
					flexDirection: "column",
					width: "100%",
				}}
			>
				<span style={{
					flex: "1"
				}}>
					{li.props.children}
				</span>
				<span style={{
					fontSize: "12px"
				}}>
					{isPreferredIcon}
					{itemName}
				</span>
			</span>
		);

		return React.cloneElement(li, li.props, itemChildren);
	}

	updateCellStatusAndColorOnEdit = (cell, updateNextSibling = false) => {
		cell.style.backgroundColor = '#e6e6e6';
		cell.classList.add('edited');

		if (updateNextSibling) {
			cell.nextSibling.style.backgroundColor = '#e6e6e6';
			cell.nextSibling.classList.add('edited');
		}
	}

	componentDidMount() {
		this.props.setRowImportActionStatusColor();
	}

	render() {
		const { templateItems, editItem, calculateQuantity, isNewTemplate, saveItemOnProductSelect, deleteAndAddItem, setImportActionToDeleteAndAddItem, deleteItem, setImportActionToDelete, productStore, isEnteralTemplate, isReadOnly, isQtyReadOnly, isImportActionDelete, isNewItem, templateItemsRowRefs, linkedTemplateId, showProductList, formSubmit } = this.props;
		const isEnteral = isEnteralTemplate();
		const isNewTemplates = isNewTemplate();
		return (
			<table className="table--preview">
				{isEnteral ? (
					<colgroup>
						<col width="225" />
						<col width="200" />
						<col width="80" />
						<col width="90" />
						<col width="120" />
						<col width="120" />
						<col width="80" />
						<col width="90" />
						<col width="90" />
						<col width="90" />
						<col width="130" />
						<col width="90" />
						<col width="90" />
						<col width="90" />
						<col width="90" />
					</colgroup>
				) : (
					<colgroup>
						<col width="200" />
						<col width="180" />
						<col width="90" />
						<col width="70" />
						<col width="70" />
						<col width="70" />
						<col width="70" />
						<col width="140" />
						<col width="85" />
						<col width="90" />
						<col width="90" />
					</colgroup>)}
				<thead>
					<tr>
						<th className="type--left">Item Id</th>
						<th className="type--left">Item Name</th>
						{isEnteral && <th className="type--right">ML</th>}
						{isEnteral && <th className="type--right">Frequency</th>}
						{isEnteral && <th className="type--right">Amount</th>}
						{isEnteral && <th className="type--right">Calories</th>}
						<th className="type--left">UOM</th>
						<th className="type--right">Temp Qty</th>
						<th className="type--right">TEMP BQTY</th>
						<th className="type--right">SO Qty</th>
						<th className="type--right">SO BQTY</th>
						<th className="type--left">Procedure Code</th>
						<th className="type--left">Action</th>
						<th className="type--left">Item Id</th>
						<th className="type--right">Actions</th>
					</tr>
				</thead>
				<tbody>
					{templateItems.map((item, index) => {
						const isDeleteAction = isImportActionDelete(index);
						const isNew = isNewItem(index);
						var itemType = "";

						if (item && item.product) {
							if (item.product.itemType && item.product.itemType.abrv === 'bottle' ||
								item.product.itemType && item.product.itemType.abrv === 'can' ||
								item.product.procedureCode === 'B4155')
								itemType = 'ml';
							else
								itemType = "";
						}

						return (<tr key={item.id} ref={(ref) => { templateItemsRowRefs[index] = ref; return true; }}>
							<td>
								<div className="u-flex--primary">
									<div className="u-mar--right--sml u-flex--grow--1">
										{
											isNew ?
												<BaasicDropdown
													disabled={isReadOnly}
													store={productStore}
													value={item.product}
													className="input--table"
													itemRender={this.productDropdownItemRender}
													onChange={(e) => {
														if (e.target.value === null)
															return;
														editItem(index, e.target.value, 'product');
														editItem(index, e.target.value.id, 'productId');
														if (isEnteral && e.target.value.itemType !== null) {
															editItem(index, 1, 'itemMls');
															editItem(index, e.target.value.calsPerMl, 'itemCals');
														}
														saveItemOnProductSelect();
													}}
												/>
												: item.product && item.product.itemId
										}
									</div>
									{isNew &&
										<BaasicButton
											disabled={isReadOnly}
											className="btn btn--icon"
											icon="u-icon u-icon--sml u-icon--search"
											onlyIcon={true}
											label="Products"
											onClick={() => { showProductList() }}
										></BaasicButton>
									}
								</div>
							</td>
							<td onClick={(e) => e.stopPropagation()}>
								{item.product && item.product.description}
							</td>
							{isEnteral &&
								<td className="table-col-input text-align-right">
									{itemType !== '' && !isNew &&
										<input
											disabled={isReadOnly}
											className="input--table input--inherit-color no-arrows input--text-align--right w--60--px u-mar--right--tny"
											onClick={this.selectValue}
											onChange={(e) => {
												this.updateCellStatusAndColorOnEdit(e.target.parentElement);
												editItem(index, e.target.value, 'mlph');
											}}
											onBlur={(e) => {
												calculateQuantity(item.id, index, e.target.value, 'itemMlph');
											}}
											value={item.mlph}
											type="number"
											min="0"
										/>
									}
								</td>
							}
							{isEnteral &&
								<td className="table-col-input text-align-right">
									{itemType !== '' && !isNew &&
										<input
											disabled={isReadOnly}
											className="input--table input--inherit-color no-arrows input--text-align--right w--60--px u-mar--right--tny"
											onClick={this.selectValue}
											onChange={(e) => {
												this.updateCellStatusAndColorOnEdit(e.target.parentElement);
												editItem(index, e.target.value, 'frequency');
											}}
											onBlur={(e) => {
												calculateQuantity(item.id, index, e.target.value, 'itemFrequency');
											}}
											value={item.frequency}
											type="number"
										/>
									}
								</td>
							}
							{isEnteral &&
								<td className="table-col-input text-align-right">
									<div className="u-flex--primary u-flex--justify-end">
										{itemType !== '' && !isNew &&
											<input
												disabled={isReadOnly}
												className="input--table input--inherit-color no-arrows input--text-align--right w--60--px u-mar--right--tny"
												onClick={this.selectValue}
												onChange={(e) => {
													this.updateCellStatusAndColorOnEdit(e.target.parentElement);
													editItem(index, e.target.value, 'itemMls');
												}}
												onBlur={(e) => {
													if (itemType === 'ml' || itemType === 'can' || itemType === 'lps') {
														calculateQuantity(item.id, index, e.target.value, 'itemMls');
													}
												}}
												value={item.itemMls}
												type="number"
												min="0"
											/>
										}
										{itemType !== '' && itemType !== 'lps' && !isNew && ' ' + itemType}
										{itemType === 'lps' && !isNew && ' btl'}
									</div>
								</td>
							}
							{isEnteral &&
								<td className="table-col-input text-align-right">
									<div className="u-flex--primary u-flex--justify-end">
										{itemType !== '' && !isNew &&
											<input
												disabled={isReadOnly}
												className="input--table input--inherit-color no-arrows input--text-align--right w--60--px u-mar--right--tny"
												onClick={this.selectValue}
												onChange={(e) => {
													this.updateCellStatusAndColorOnEdit(e.target.parentElement);

													editItem(index, e.target.value, 'itemCals')
												}}
												onBlur={(e) => {
													if (itemType === 'ml' || itemType === 'can' || itemType === 'lps') {
														calculateQuantity(item.id, index, e.target.value, 'itemCal');
													}
												}}
												value={item.itemCals}
												type="number"
												min="0"
											/>
										}
										<span>{isEnteral && itemType !== '' && !isNew && ' kcal'}</span>
									</div>
								</td>
							}
							<td>
								{item.product && item.product.uoM}
							</td>
							<td className="table-col-input text-align-right" style={isQtyReadOnly ? { opacity: 0.7, backgroundColor: "#e6e6e6" } : {}}>
								<input
									disabled={isReadOnly}
									className="input--table input--inherit-color no-arrows input--text-align--right w--60--px u-mar--right--tny"
									onClick={this.selectValue}
									onChange={(e) => {
										this.updateCellStatusAndColorOnEdit(e.target.parentElement, true);

										editItem(index, e.target.value, 'templateQuantity')
									}}
									onBlur={() => { formSubmit(); }}
									value={item.templateQuantity}
									type="number"
									min="0"
									readOnly={isQtyReadOnly}
								/>
							</td>
							<td className="table-col-input text-align-right" style={isQtyReadOnly ? { opacity: 0.7, backgroundColor: "#e6e6e6" } : {}}>
								<input
									disabled={isReadOnly}
									className="input--table input--inherit-color no-arrows input--text-align--right w--60--px u-mar--right--tny"
									onClick={this.selectValue}
									onChange={(e) => {
										this.updateCellStatusAndColorOnEdit(e.target.parentElement);

										editItem(index, e.target.value, 'templateBillingQuantity')
									}}
									onBlur={() => { formSubmit(); }}
									value={item.templateBillingQuantity}
									type="number"
									min="0"
									readOnly={isQtyReadOnly}
								/>
							</td>
							<td className="table-col-input text-align-right" style={isQtyReadOnly ? { opacity: 0.7, backgroundColor: "#e6e6e6" } : {}}>
								<input
									disabled={isReadOnly}
									className="input--table input--inherit-color no-arrows input--text-align--right w--60--px u-mar--right--tny"
									onClick={this.selectValue}
									onChange={(e) => {
										this.updateCellStatusAndColorOnEdit(e.target.parentElement);
										editItem(index, e.target.value, 'orderQuantity')
									}}
									onBlur={() => { formSubmit(); }}
									value={item.orderQuantity}
									type="number"
									min="0"
									readOnly={isQtyReadOnly}
								/>
							</td>
							<td className="table-col-input text-align-right" style={isQtyReadOnly ? { opacity: 0.7, backgroundColor: "#e6e6e6" } : {}}>
								<input
									disabled={isReadOnly}
									className="input--table input--inherit-color no-arrows input--text-align--right w--60--px u-mar--right--tny"
									onClick={this.selectValue}
									onChange={(e) => {
										this.updateCellStatusAndColorOnEdit(e.target.parentElement);
										editItem(index, e.target.value, 'billingQuantity')
									}}
									onBlur={() => { formSubmit(); }}
									value={item.billingQuantity}
									type="number"
									min="0"
									readOnly={isQtyReadOnly}
								/>
							</td>
							<td>
								{item.procedureCode && item.procedureCode}
							</td>
							<td onClick={this.testClick}>
								{item.importAction && item.importAction.name}
							</td>
							<td>{item.templateItemId}</td>
							<td className="type--right">
								<div className="table__icons is-hidden">
									{
										!isNewTemplates ?
											<BaasicButton
												disabled={isQtyReadOnly || isReadOnly}
												className="btn btn--icon"
												icon="u-icon u-icon--update-table u-icon--sml"
												label="Change"
												onlyIcon={true}
												onClick={() => ((isNew && item.id.startsWith("new")) || isNewTemplates || (item.importAction && item.importAction.name === "Insert")) ? deleteAndAddItem(index, item, linkedTemplateId) : setImportActionToDeleteAndAddItem(index, templateItemsRowRefs[index], item)}
											></BaasicButton>
											: null
									}
									<BaasicButton
										disabled={isQtyReadOnly || isReadOnly}
										className="btn btn--icon is-delete"
										icon={!isDeleteAction ? "u-icon u-icon--delete u-icon--sml" : "u-icon u-icon--unapproved u-icon--sml"}
										label={!isDeleteAction ? "Delete" : "Undo"}
										onlyIcon={true}
										onClick={() => ((isNew && item.id.startsWith("new")) || isNewTemplates || (item.importAction && item.importAction.name === "Insert")) ? deleteItem(index, item, linkedTemplateId) : setImportActionToDelete(index, templateItemsRowRefs[index])}
									></BaasicButton>
								</div>
							</td>
						</tr>);
					}
					)}
				</tbody>
			</table>
		);
	}
});

TemplateItemsTable.propTypes = {
	templateItems: PropTypes.object,
	editItem: PropTypes.func,
	validate: PropTypes.func,
	saveItemOnProductSelect: PropTypes.func,
	deleteAndAddItem: PropTypes.func,
	setImportActionToDeleteAndAddItem: PropTypes.func,
	deleteItem: PropTypes.func,
	calculateQuantity: PropTypes.func,
	productStore: PropTypes.object,
	setImportActionToDelete: PropTypes.func,
	isEnteralTemplate: PropTypes.func,
	isReadOnly: PropTypes.bool,
	isQtyReadOnly: PropTypes.bool,
	isImportActionDelete: PropTypes.func,
	isNewItem: PropTypes.func,
	isNewTemplate: PropTypes.func,
	templateItemsRowRefs: PropTypes.array,
	setRowImportActionStatusColor: PropTypes.func,
	deleteNewTemplate: PropTypes.func,
	linkedTemplateId: PropTypes.object,
	subCategory: PropTypes.object,
	showProductList: PropTypes.func,
	formSubmit: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplateItemEditTemplate);